import React, { useEffect } from "react";
import { Alert as MuiAlert, CardContent } from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useCustomerPaymentInfo } from "./index";
import BpointPaymentForm from "./payment-gateways/BpointPaymentForm";
import SawfishPaymentForm from "./payment-gateways/SawfishPaymentForm";
import {
  OneSolomonPageBackground,
  resolveIsCompanyOneSolomons,
} from "./oneSolomonUi";

const Alert = styled(MuiAlert)(spacing);

/**
 * PaymentForm wrapper component
 * Renders the appropriate payment gateway form based on the selected gateway
 */
const PaymentForm = () => {
  const { values: customerInfo } = useCustomerPaymentInfo();
  const navigate = useNavigate();
  const paymentGateway = customerInfo?.paymentGateway || "bpoint";
  const isCompanyOneSolomons = resolveIsCompanyOneSolomons(
    customerInfo?.company_uuid,
    customerInfo?.isCompanyOneSolomons
  );

  useEffect(() => {
    if (customerInfo?.transaction_uuid === undefined) {
      navigate("/", { replace: true });
    }
  }, [customerInfo, navigate]);

  const gatewayForm = (() => {
    switch (paymentGateway) {
      case "bpoint":
        return <BpointPaymentForm />;

      case "sawfish":
        return <SawfishPaymentForm />;

      default:
        return (
          <CardContent>
            <Alert severity="error">
              Unknown payment gateway: {paymentGateway}. Please contact support.
            </Alert>
          </CardContent>
        );
    }
  })();

  return (
    <>
      {isCompanyOneSolomons && <OneSolomonPageBackground />}
      {gatewayForm}
    </>
  );
};

export default PaymentForm;
